import { motion, useReducedMotion } from "framer-motion";

import ChatConversationPane from "./ChatConversationPane";
import ChatHistory from "./ChatHistory";
import ChatSidebarHeader from "./ChatSidebarHeader";
import ChatSignedOut from "./ChatSignedOut";
import type { ChatController } from "~/hooks/useChatController";

interface ChatSidebarProps {
	controller: ChatController;
}

const ChatSidebar = ({ controller }: ChatSidebarProps) => {
	const reduceMotion = useReducedMotion();
	const { isSignedIn, view, handleSelectThread } = controller;

	return (
		<motion.aside
			initial={reduceMotion ? { opacity: 0 } : { x: "100%" }}
			animate={reduceMotion ? { opacity: 1 } : { x: 0 }}
			exit={reduceMotion ? { opacity: 0 } : { x: "100%" }}
			transition={
				reduceMotion
					? { duration: 0.2 }
					: { type: "spring", stiffness: 320, damping: 34 }
			}
			className="fixed inset-y-0 right-0 z-50 flex tablet:w-md w-full flex-col tablet:rounded-l-2xl border-slate-200 border-l bg-white shadow-[0_0_60px_-15px_rgba(15,23,42,0.35)] dark:border-slate-700 dark:bg-slate-900"
		>
			<ChatSidebarHeader controller={controller} />

			{!isSignedIn && <ChatSignedOut />}

			{isSignedIn && view === "history" && (
				<ChatHistory onSelectThread={handleSelectThread} />
			)}

			{isSignedIn && view === "conversation" && (
				<ChatConversationPane controller={controller} />
			)}
		</motion.aside>
	);
};

export default ChatSidebar;
